module.exports = __webpack_public_path__ + "img/main-consign-sfapp.9a3ac9c.png";